import type { Roadmap } from 'common/api/endpoints/roadmaps';

/**
 * Find a roadmap by URL name with support for old URL name mapping
 */
export function findRoadmapByURLName(
  roadmaps: Roadmap[],
  urlName: string,
  oldURLNames?: Record<string, string>,
  includeArchived: boolean = false,
): Roadmap | undefined {
  // First, check if this URL name maps to a different URL name
  const mappedURLName = oldURLNames?.[urlName] ?? urlName;

  return roadmaps.find((roadmap) => {
    const matchesURL = roadmap.urlName === urlName || roadmap.urlName === mappedURLName;
    const isVisible = includeArchived || !roadmap.archived;
    return matchesURL && isVisible;
  });
}

/**
 * Find a roadmap by ID
 */
export function findRoadmapByID(
  roadmaps: Roadmap[],
  roadmapID: string,
  includeArchived: boolean = false,
): Roadmap | undefined {
  return roadmaps.find((roadmap) => {
    const matchesID = roadmap._id === roadmapID;
    const isVisible = includeArchived || !roadmap.archived;
    return matchesID && isVisible;
  });
}
